import { useRef, useEffect, useState } from 'react';

interface EditableNumberInputProps {
    children?: React.ReactNode;
    editable:boolean;
    value:number;
    maxLength?:number;
    inputDivClassName?:string;
    inputClassName?:string;
    inputTextBefore?: string;
    inputTextAfter?: string;
    spanDivClassName?:string;
    spanClassName?:string;
    spanTextAfter?: string;   
    onEditStart : () => void,
    onEditEnd : () => void,
    onValueChanged : (v:number) => void;
}

function EditableNumberInput(props:EditableNumberInputProps) { 
  const [isEditing, setIsEditing] = useState(false);
  const internalRef = useRef<HTMLInputElement>(null);
  const debounceRef = useRef<NodeJS.Timeout|null>(null);

  function valueChangeWithDebounce(newVal:number) {
    if(debounceRef.current!=null) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      props.onValueChanged(newVal);
    }, 150);
  }


  useEffect(() => {
    if (isEditing && internalRef.current) {
      internalRef.current.focus();
    }
  }, [isEditing]);

  const handleEdit = () => {
    if(props.editable) {
        setIsEditing(true);
        props.onEditStart();
    }
  };

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if(event.key == 'Enter') {
      console.log('check enter');
      try {
        if(internalRef.current?.value === '') {
          valueChangeWithDebounce(NaN);
        } else {
          const newVal = parseInt(internalRef.current?.value || 'error');     
          if(!isNaN(newVal)) {
            valueChangeWithDebounce(newVal);
          }
        }
      } catch (err) {      
      }
      setIsEditing(false);
      props.onEditEnd();
    }
  }

  function handleBlur(event: React.ChangeEvent<HTMLInputElement>) { 
    try {
        if(event.target.value === '') {
          valueChangeWithDebounce(NaN);
        } else {
          let newVal = parseInt(event.target.value);     
          if(!isNaN(newVal)) {
            valueChangeWithDebounce(newVal);
          }
        }
    } catch (err) {      
    }
    setIsEditing(false);
    props.onEditEnd();
  };

  return isEditing ? (
    <div className={props.inputDivClassName}>
      {props.inputTextBefore!=null ? <span style={{marginRight: '3px'}}>{props.inputTextBefore}</span> : null}
      <input className={props.inputClassName} ref={internalRef} 
              onBlur={handleBlur} 
              onKeyDown={handleKeyDown}              
              defaultValue={isNaN(props.value) ? '' : props.value} 
              maxLength={props.maxLength}/>
      {props.inputTextAfter!=null ? <span style={{marginLeft: '3px'}}>{props.inputTextAfter}</span> : null}
    </div>
  ) : (
    <div className={props.spanDivClassName} onClick={handleEdit} style={props.editable?{cursor: 'pointer'}:{}}>
      <span className={props.spanClassName} >{isNaN(props.value)?'/':props.value}</span>
      {props.spanTextAfter!=null ? <span style={{marginLeft: '3px'}}>{!props.value || isNaN(props.value)?'':props.spanTextAfter}</span> : null}
    </div>
  );
}

export default EditableNumberInput;